export default "__VITE_ASSET__CuJcXRBa__"